export default class SessionWrapper {
    constructor(storageType, storageKey) {
        if (storageType !== 'localStorage' && storageType !== 'sessionStorage') {
            throw 'SessionWrapper: Unsupported storage type ' + storageType;
        }

        this._storedData = { };
        if (typeof self !== 'undefined' && self[storageType]) {
            const storedData = self[storageType].getItem(storageKey);
            this._storedData = storedData ? JSON.parse(storedData) : { };
        }

        this._syncWithStorage = function(){
            if (typeof self !== 'undefined' && self[storageType]) {
                self[storageType].setItem(storageKey, JSON.stringify(this._storedData));
            }
        };
    }
    
    getItem(key) {
        return this._storedData[key] || null;
    }
    
    setItem(key, value) {
        this._storedData[key] = value;
        this._syncWithStorage();
    }
    
    clear() {
        this._storedData = { };
        this._syncWithStorage();
    }
}